import React from "react";
import styles from "./skills.module.scss";

const Skills: React.FC = () => {
  const technicalSkills = [
    "JavaScript",
    "TypeScript",
    "NodeJS",
    "NestJS",
    "React",
    "Redux",
    "TypeORM",
    "Postgres",
    "MySQL",
    "MongoDB",
    "Kubernetes",
    "Docker",
    "Go",
    "Java",
  ];

  const softSkills = ["Inventiveness", "Ambitious", "Teamplayer", "Cooking"];

  const certificates = ["French DELF A1", "Brandschutzhelfer Oct-22"];

  return (
    <div className={styles.skillsContainer}>
      <div className={styles.category}>
        <h3 className={styles.categoryTitle}>Technical Skills</h3>
        <div className={styles.skillGrid}>
          {technicalSkills.map((skill, index) => (
            <div key={index} className={styles.skillBadge}>
              {skill}
            </div>
          ))}
        </div>
      </div>

      <div className={styles.category}>
        <h3 className={styles.categoryTitle}>Soft Skills</h3>
        <div className={styles.skillGrid}>
          {softSkills.map((skill, index) => (
            <div
              key={index}
              className={`${styles.skillBadge} ${styles.softSkill}`}
            >
              {skill}
            </div>
          ))}
        </div>
      </div>

      <div className={styles.category}>
        <h3 className={styles.categoryTitle}>Certificates</h3>
        <div className={styles.skillGrid}>
          {certificates.map((cert, index) => (
            <div
              key={index}
              className={`${styles.skillBadge} ${styles.certificate}`}
            >
              {cert}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
